module.exports = __webpack_public_path__ + "img/39_41.e8442b8b.png";